'use strict';

var core = require('@ts-rest/core');
var zod = require('zod');

const ToestemmingenEntitySchema = zod.z.object({
    toestemmingNeemContactOp: zod.z.boolean(),
    toestemmingPREM: zod.z.boolean(),
});

const VerrichtingSchema = zod.z.object({
    data: zod.z.record(zod.z.unknown()),
    id: zod.z.string().uuid(),
    serviceGroupName: zod.z.string(),
    type: zod.z.string(),
    uitgevoerdDatumTijd: zod.z.coerce.date(),
});
const VerrichtingenEntitySchema = zod.z.object({
    verrichtingen: zod.z.array(VerrichtingSchema),
});

const c$2 = core.initContract();
const toestemmingenContract = c$2.router({
    getToestemmingen: {
        metadata: {
            openApiTags: ['Patient'],
        },
        method: 'GET',
        path: `/api/external/mijnksyos/patients/:patientId/toestemmingen`,
        pathParams: zod.z.object({
            patientId: zod.z.string().uuid(),
        }),
        responses: {
            200: ToestemmingenEntitySchema,
        },
        summary: 'Get the toestemmingen for a patient',
    },
    setToestemmingen: {
        body: ToestemmingenEntitySchema.partial(),
        metadata: {
            openApiTags: ['Patient'],
        },
        method: 'PATCH',
        path: `/api/external/mijnksyos/patients/:patientId/toestemmingen`,
        responses: {
            200: ToestemmingenEntitySchema,
        },
    },
});

const c$1 = core.initContract();
const verrichtingenContract = c$1.router({
    getVerrichtingen: {
        metadata: {
            openApiTags: ['Patient'],
        },
        method: 'GET',
        path: `/api/external/mijnksyos/patients/:patientId/verrichtingen`,
        pathParams: zod.z.object({
            patientId: zod.z.string().uuid(),
        }),
        query: zod.z.object({
            serviceGroupName: zod.z.string().optional(),
        }),
        responses: {
            200: VerrichtingenEntitySchema,
        },
        summary: 'Get the verrichtingen for a patient',
    },
});

const c = core.initContract();
const clientSafeContract = c.router({
    toestemmingen: toestemmingenContract,
    verrichtingen: verrichtingenContract,
});

exports.ToestemmingenEntitySchema = ToestemmingenEntitySchema;
exports.VerrichtingenEntitySchema = VerrichtingenEntitySchema;
exports.clientSafeContract = clientSafeContract;
exports.toestemmingenContract = toestemmingenContract;
exports.verrichtingenContract = verrichtingenContract;
//# sourceMappingURL=index.cjs.map
